import React from 'react';
import { dateFormation, isEmpty, isMobilePage } from '../../common/cores';
import BackButton from './BackButton';

const Answer = (props) => {
    console.log(props);
    const { selected, type } = props;
    return (
            <div data-v-778df7a6="" data-v-8a1260b4="" className="inquiry-read scrollable-auto column mobile-w-100" style={{display: (isMobilePage() && !props.showHis) && "none"}}>
                { isMobilePage() && <BackButton showHisotry={props.showHisotry}/>}
                <div data-v-778df7a6="" className="read column">
                   
                    <div data-v-778df7a6="" className="title row" style= {{ flexDirection: "row" }}>
                        <span data-v-778df7a6="" className="text" style= {{ opacity: "0.6" }}>{type === "message" ? "쪽지 내용" : "1:1문의 내용"}</span>
                        <div data-v-778df7a6="" className="spacer"></div> <span data-v-778df7a6="" className="text"
                            style= {{ opacity: "0.6" }}><i data-v-e56d064c="" data-v-778df7a6=""
                                className="margin-right-5 fa-regular fa-timer"></i>{type === "message" ? dateFormation(selected.date) :  dateFormation(selected.created_date)}</span>
                    </div>
                    <div data-v-778df7a6="" className="inquiry-title row" style= {{ flexDirection: "row" }}><span
                            data-v-778df7a6="" className="text"></span> 
                            <span data-v-778df7a6="" className="text">{selected.title}</span></div>
                    <div data-v-778df7a6="" className="inquiry-content row" style= {{ flexDirection: "row" }}>
                        { type === "message" && <div data-v-778df7a6="" className="column white-break-spaces"  dangerouslySetInnerHTML={{ '__html': !isEmpty(selected.description) ? selected.description : "" }}></div>}
                        { type === "question" && <div data-v-778df7a6="" className="column white-break-spaces"  dangerouslySetInnerHTML={{ '__html': !isEmpty(selected.question) ? selected.question : "" }}></div>}
                    </div>
                    {
                        !isEmpty(selected.answer) &&
                    <div data-v-778df7a6="" className="inquiry-answer column">답변
                        <p>{dateFormation(selected.answered_date)}</p>
                        <div data-v-778df7a6="" className="column white-break-spaces"  dangerouslySetInnerHTML={{ '__html': !isEmpty(selected.answer) ? selected.answer : "" }}>
                        </div>
                    </div>
                   }
                   
                </div>
            </div>
    )
}

export default Answer;


// WEBPACK FOOTER //
// ./src/components/account/Answer.js